import api from '../lib/api';

export const PICKUP_ZONES_LOADING = 'PICKUP_ZONES_LOADING';
export const FETCH_PICKUP_ZONES = 'FETCH_PICKUP_ZONES';
export const CREATE_PICKUP_ZONE = 'CREATE_PICKUP_ZONE';
export const UPDATE_PICKUP_ZONE = 'UPDATE_PICKUP_ZONE';
export const DELETE_PICKUP_ZONE = 'DELETE_PICKUP_ZONE';
export const BULK_UPLOAD_PICKUP_ZONES = 'BULK_UPLOAD_PICKUP_ZONES';

function createPickupZone(args) {
  return (dispatch) => api.createPickupZone(args)
    .then((data) => {
      dispatch({ type: CREATE_PICKUP_ZONE, payload: data });
      return data;
    });
}

function updatePickupZone(id, updateObj) {
  return (dispatch) => api.updatePickupZone(id, updateObj)
    .then((data) => {
      dispatch({ type: UPDATE_PICKUP_ZONE, payload: data });
      return data;
    });
}

function deletePickupZone(id) {
  return (dispatch) => api.deletePickupZone(id)
    .then((response) => response.data)
    .then((data) => {
      dispatch({ type: DELETE_PICKUP_ZONE, payload: data });
      return data;
    });
}

function fetchPickupZones(marketId) {
  return (dispatch) => {
    dispatch({ type: PICKUP_ZONES_LOADING, payload: true });

    return api.getPickupZones({ market_id: marketId })
      .then((data) => {
        dispatch({ type: FETCH_PICKUP_ZONES, payload: data });
        return data;
      })
      .then((data) => {
        dispatch({ type: PICKUP_ZONES_LOADING, payload: false });
        return data;
      })
      .catch((data) => {
        dispatch({ type: PICKUP_ZONES_LOADING, payload: false });
        return data;
      });
  };
}

function bulkUploadPickupZones(marketId, zonesData, disableOldZones) {
  return (dispatch) => api.bulkUploadPickupZones(marketId, zonesData, disableOldZones)
    .then((response) => response.data)
    .then((data) => {
      dispatch({ type: BULK_UPLOAD_PICKUP_ZONES, payload: data });
      return data;
    });
}

export default {
  fetchPickupZones,
  updatePickupZone,
  createPickupZone,
  deletePickupZone,
  bulkUploadPickupZones,
};
